import { api_service } from "../../Api/api_service";
import { IRequestBody } from "../../Constants/interfaces";
import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
export const PostFileUpload = (
  data: any,
  successCallBack: any,
  errorCallBack: any,
  progressCallBack: any
) => {
  data.progressCallBack = progressCallBack;
  return api_service
    .post(data)
    .then((response) => {
      // successCallBack(response.data, "retailer_image_upload");
      return response.data;
    })
    .catch((err) => {
      errorCallBack(err, "post_file_upload");
    });
};

export const CreateFileListEntry = (
  data: any,
  successCallBack: any,
  errorCallBack: any
) => {
  return api_service
    .post(data)
    .then((response) => {
      successCallBack(response.data, "create_file_list_entry");
      return response.data;
    })
    .catch((err) => {
      errorCallBack(err, "create_file_list_entry");
    });
};

export const GetFileLists = (
  data: any,
  successCallBack: any,
  errorCallBack: any
) => {
  return api_service
    .get(data)
    .then((response) => {
      successCallBack(response.data, "get_file_lists");
      // return response.data;
    })
    .catch((err) => {
      errorCallBack(err, "get_file_lists");
    });
};

export const DeleteFileEntry = (
  data: any,
  successCallBack: any,
  errorCallBack: any
) => {
  return api_service
    .delete(data)
    .then((response) => {
      successCallBack(response.data, "delete_file_entry");
      // return response.data;
    })
    .catch((err) => {
      errorCallBack(err, "delete_file_entry");
    });
};
